import React, { useEffect, useState } from 'react'
import { Spin ,Table,Button,message,Select  } from 'antd';
import { withApollo } from '@apollo/client/react/hoc';
import updateTableOrderItemStatusInBulk from '../../mutations/updateTableOrderItemStatusInBulk'
import getSiteOrderByItemStatus from '../../queries/getSiteOrderByItemStatus';
import tableOrderUpdatedV2 from '../../subscription/tableOrderUpdatedV2';
import unslugify from 'unslugify';

class ItemCount extends  React.Component {
    constructor(props) {
        super(props);
        this.state = {
            countData: [],
            loading: true,
            dataPayload: null,
            readyAllLoading: false,
            selectedItem: null,
            MainDataSource: [],
            selectedMenuTypes:[]
        };

    }

    componentDidMount() {
             this.getSiteOrder()
             this.tableOrderUpdatedV2ItemCount()
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.orderCreateSub !== this.props.orderCreateSub) {
            if (this.props.orderCreateSub) {
                this.createDataForBulkAcceptUpdated(this.props.orderCreateSub)
                this.filterRecordUpdated(this.props.orderCreateSub)
            }
        }
        if (prevState.selectedMenuTypes !== this.state.selectedMenuTypes) {
        this.filterRecord(this.state.MainDataSource);
        this.createDataForBulkAccept(this.state.MainDataSource);
    }
    }

    componentWillUnmount() {
          if(this.subscriptionV2){
            // console.log("unsubscribing tableOrderUpdatedV2ItemCount subscription")
            this.subscriptionV2.unsubscribe();
          }
    }

    tableOrderUpdatedV2ItemCount = () =>{
        let that = this
        let retryAttempts = 0; 
        this.subscriptionV2 = this.props.client.subscribe({
            query: tableOrderUpdatedV2,
            variables:{
                siteId: this.props.siteId
            }
        }).subscribe({
            next: ({data}) => {
            //    console.log("restaurantData tableOrderUpdatedV2 ::",data.tableOrderUpdatedV2)
              retryAttempts = 0;
              let order = data.tableOrderUpdatedV2
            //   console.log("order",order)


                // if (filteredArr) {
                     this.createDataForBulkAcceptUpdated(order)
                     this.filterRecordUpdated(order)
                // }
              
             
            },
            error: (err) => {
                retryAttempts++;
                console.log('table updated v2 error', err);
                const maxRetryAttempts = 5;

                if (retryAttempts <= maxRetryAttempts) {
                  const delay = Math.pow(2, retryAttempts) * 1000; // Exponential backoff with base 2
        
                  setTimeout(this.tableOrderUpdatedV2ItemCount, delay);

                } else {
                  console.log('Max retry attempts reached. Stopping retries.');
                }
            }
        });
    }

     getSiteOrder() {
        //this.loadingSpin()
        this.props.client.query({
            query: getSiteOrderByItemStatus,
            fetchPolicy: 'network-only',
            variables: {
                station: this.props.station,
                // station:'kitchen',
                status: ['IN_PROCESS','KOT_GENERATED'],
                skip: 0,
                limit: 200
                // tableNo:'1'

            }
        })
            .then(({ data }) => {
                //  console.log('getSiteOrderByItemStatus::::', data)
                if (data.getSiteOrderByItemStatus != null) {
                   
                    const arr = data.getSiteOrderByItemStatus;
                    // console.log("arr",arr)
                        // console.log('🔴 RAW API DATA::', JSON.stringify(data.getSiteOrderByItemStatus, null, 2))

                    const filteredArr = arr.filter(order => order.orderList.some(item => item.services.length > 0));
                    filteredArr.sort((a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0));

                   this.createDataForBulkAccept(filteredArr)

                    this.filterRecord(filteredArr)

                }
            })
            .catch(err => {
                console.log(`Catch: handleFormSubmit: error: ${err}`)
            })
    }

    createDataForBulkAccept(arr) {

        this.setState({MainDataSource:arr})

        let payloadArray = [];

        arr.forEach(order => {
            if (order.orderList && order.orderList.length > 0) {
                order.orderList.forEach(orderItem => {
                    if (orderItem.services && orderItem.services.length > 0) {
                        orderItem.services.forEach(service => {
                            // const itemName = service.serviceName; // Assuming serviceName is the item name
                            const isFiltered = this.state.selectedMenuTypes.length > 0;
                            if (isFiltered && !this.state.selectedMenuTypes.includes(order.orderFrom)) {
                                return; // skip
                            }
                            const itemName = service.serviceName;
                            // const itemName = isFiltered
                            //     ? `${service.serviceName}_${order.orderFrom}`
                            //     : service.serviceName;
                            // const itemName = `${service.serviceName}_${order.orderFrom}`;
                            const itemPayload = {
                                subOrderId: orderItem.subOrderId,
                                serviceId: service.uId,
                                status: service.status == 'KOT_GENERATED'? 'IN_PROCESS' : 'PREPARED'
                            };

                            let existingPayload = payloadArray.find(item => item[itemName]);
                            if (!existingPayload) {
                                existingPayload = {};
                                existingPayload[itemName] = [];
                                payloadArray.push(existingPayload);
                            }

                            const existingItemArray = existingPayload[itemName];

                            const existingItem = existingItemArray.find(item => item.id === order.id);

                            if (existingItem) {
                                existingItem.items.push({ ...itemPayload });
                            } else {
                                existingItemArray.push({
                                    id: order.id,
                                    items: [{ ...itemPayload }]
                                });
                            }
                        });
                    }
                });
            }
        });

        // console.log("Payload Create Data::", payloadArray);
        // console.log('🟡 PAYLOAD BANA::', JSON.stringify(payloadArray, null, 2))


       this.setState({dataPayload: payloadArray})

    }


    createDataForBulkAcceptUpdated(order){
    
            let DataSourceDummy = JSON.parse(JSON.stringify(this.state.MainDataSource))
            let DataSource
            if(order.tableOrderStatus == "CLOSED"){
             DataSource = DataSourceDummy.filter((data => data.orderId != order.orderId))
            // console.log("inside createDataForBulkAcceptUpdated Record:::", DataSource)
            }else{
                DataSource = DataSourceDummy
            }
            let index = DataSource && DataSource.findIndex((data)=> data.orderId == order.orderId)
            if(index != -1){
                DataSource[index] = order
            }else{
                if(index == -1 && order.tableOrderStatus != "CLOSED"){
                    DataSource.push(order)
                }
            }
            DataSource.sort((a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0));
            let payloadArray = [];

        DataSource && DataSource.forEach(order => {
            if (order.orderList && order.orderList.length > 0) {
                order.orderList.forEach(orderItem => {
                    if (orderItem.services && orderItem.services.length > 0) {
                        orderItem.services.forEach(service => {
                           if(service.station == this.props.station && (service.status == 'KOT_GENERATED' || service.status == 'IN_PROCESS' )){
                            // const itemName = service.serviceName; 
                            // const itemName = `${service.serviceName}_${order.orderFrom}`;

                               const isFiltered = this.state.selectedMenuTypes.length > 0;
                               if (isFiltered && !this.state.selectedMenuTypes.includes(order.orderFrom)) {
                                   return; // skip
                               }
                            //    const itemName = isFiltered
                            //        ? `${service.serviceName}_${order.orderFrom}`
                            //        : service.serviceName;

                            const itemName = service.serviceName;
                            const itemPayload = {
                                subOrderId: orderItem.subOrderId,
                                serviceId: service.uId,
                                status: service.status == 'KOT_GENERATED'? 'IN_PROCESS' : 'PREPARED'
                            };

                            let existingPayload = payloadArray.find(item => item[itemName]);
                            if (!existingPayload) {
                                existingPayload = {};
                                existingPayload[itemName] = [];
                                payloadArray.push(existingPayload);
                            }

                            const existingItemArray = existingPayload[itemName];
                            const existingItem = existingItemArray.find(item => item.id === order.id);

                            if (existingItem) {
                                existingItem.items.push({ ...itemPayload });
                            } else {
                                existingItemArray.push({
                                    id: order.id,
                                    items: [{ ...itemPayload }]
                                });
                            }
                        }
                        });
                    }
                });
            }
        });

        // console.log("Payload Create Data::", payloadArray);


       this.setState({dataPayload: payloadArray})
       
    }

    filterRecordUpdated(order) {
  
        let orderListDummy = JSON.parse(JSON.stringify(this.state.MainDataSource));
        let orderList
        if(order.tableOrderStatus == "CLOSED"){
          orderList = orderListDummy.filter((data => data.orderId != order.orderId))
            // console.log("inside Filter Record:::", orderList)
        }else{
         orderList = orderListDummy 
        }

        let index = orderList && orderList.findIndex((data)=> data.orderId == order.orderId)

        if(index != -1){
            orderList[index] = order
        }else{
            if(index == -1 && order.tableOrderStatus != "CLOSED"){
                orderList.push(order)
            }
        }
        orderList.sort((a, b) => new Date(a.timestamp || 0) - new Date(b.timestamp || 0));
        const serviceObj = {};
        // console.log("orderList:::", orderList)
        orderList.forEach((order) => {
            order.orderList.forEach((subOrder) => {
                subOrder.services.forEach((service) => {
                    if(service.station == this.props.station && (service.status == 'KOT_GENERATED' || service.status == 'IN_PROCESS' )){
                    // const serviceName = service.serviceName;
                    // const serviceName = `${service.serviceName}_${order.orderFrom}`;
                    const isFiltered = this.state.selectedMenuTypes.length > 0;
                    if (isFiltered && !this.state.selectedMenuTypes.includes(order.orderFrom)) {
                        return;
                     }

                    // const serviceName = isFiltered ? `${service.serviceName}_${order.orderFrom}` : service.serviceName;
                    const serviceName = `${service.serviceName}_${service.status}`;

                    const qty = service.qty;
                    const status = service.status; // Assuming status is available in your data
    
                    if (!serviceObj.hasOwnProperty(serviceName)) {
                        serviceObj[serviceName] = [];
                    }
    
                    const existingIndex = serviceObj[serviceName].findIndex(item => item.status === status);
                    
                    if (existingIndex !== -1) {
                        // If exists, update the quantity
                        serviceObj[serviceName][existingIndex].quantity += qty;
                    } else {
                        // If doesn't exist, push a new entry
                        serviceObj[serviceName].push({
                            quantity: qty,
                            status: status,
                            productName: service.serviceName,
                            key: serviceName,
                            // subOrderFrom: order.orderFrom
                            attachedCat: service.attachedCat,
                        });
                    }
                  }
                });
            });
        });
    
        // console.log("data from object", serviceObj);
    
        const newArr = [];
    
        for (const [name, entries] of Object.entries(serviceObj)) {
            entries.forEach((entry) => {
                newArr.push({
                    // productName: name,
                    productName: entry.productName,
                    quantity: entry.quantity,
                    status: entry.status,
                    key: name,
                    // subOrderFrom: entry.subOrderFrom
                     attachedCat: entry.attachedCat,
                });
            });
        }
    
        //  console.log("final data", newArr);

        this.setState({countData:newArr,loading:false,MainDataSource:orderList})
    
    }
    

     filterRecord(data) {
        // console.log("data", data)
        var orderList = data;
        const serviceObj = {};
    
        orderList.forEach((order) => {
            order.orderList.forEach((subOrder) => {
                subOrder.services.forEach((service) => {
                    // const serviceName = service.serviceName;
                    // const serviceName = `${service.serviceName}_${order.orderFrom}`;

                    // agar is filtred off h to service name else jo filter laga h wahi menus ka data 
                    if(service.station == this.props.station && (service.status == 'KOT_GENERATED' || service.status == 'IN_PROCESS')){
                      const isFiltered = this.state.selectedMenuTypes.length > 0;
                    if (isFiltered && !this.state.selectedMenuTypes.includes(order.orderFrom)) {
                        return;
                     }

                    // const serviceName = isFiltered ? `${service.serviceName}_${order.orderFrom}` : service.serviceName;
                       // CHANGE: key ab sirf serviceName + status hoga
                    // subOrderFrom hata diya — consolidate karne ke liye
                    // same item different sources ek row mein aayenge
                    const serviceName = `${service.serviceName}_${service.status}`;
                    const qty = service.qty;
                    const status = service.status; // Assuming status is available in your data
    
                    if (!serviceObj.hasOwnProperty(serviceName)) {
                        serviceObj[serviceName] = [];
                    }

                    // console.log("serviceObj")
    
                    const existingIndex = serviceObj[serviceName].findIndex(item => item.status === status);
                    
                    if (existingIndex !== -1) {
                        // If exists, update the quantity
                        // serviceObj[serviceName][existingIndex].quantity += qty;
                        // same item same status mila — qty add karo
                        serviceObj[serviceName][existingIndex].quantity += qty;
                    } else {
                        // If doesn't exist, push a new entry
                        serviceObj[serviceName].push({
                            quantity: qty,
                            status: status,
                            productName: service.serviceName,
                            key: serviceName,
                            // subOrderFrom: order.orderFrom
                            attachedCat: service.attachedCat,

                        });
                    }
                    }
                   
                });
                
            });
        });
    
        // console.log("data from object", serviceObj);
    
        const newArr = [];
    
        for (const [name, entries] of Object.entries(serviceObj)) {
            entries.forEach((entry) => {
                newArr.push({
                    // productName: name,
                    productName: entry.productName,
                    quantity: entry.quantity,
                    status: entry.status,
                    key: name,
                    attachedCat: entry.attachedCat,
                    // subOrderFrom: entry.subOrderFrom
                });
            });
        }
    
        // console.log("final data", newArr);
        // console.log('🟢 TABLE DATA (countData)::', JSON.stringify(newArr, null, 2))

        this.setState({countData:newArr,loading:false})
    
    }

    
    callReadyAll(payload){ 
        return new Promise((resolve,reject)=>{
          this.props.client.mutate({
              mutation: updateTableOrderItemStatusInBulk,
              variables: payload
          }).then(({ data }) => {
              if (data.updateTableOrderItemStatusInBulk) {
                 
                //  console.log("Mutation Success", data.updateTableOrderItemStatusInBulk)
                  resolve(true)
                
              }
          }).catch((err) => {
              resolve(true)
              console.log(`Catch: updateTableOrderItemStatusInBulk:`,err)
          })
        })
     
    }

    async readyAll(data) {

        //    console.log('🔵 BUTTON CLICK ROW DATA::', data)
        //  return
    
        let BulkOperationData = JSON.parse(JSON.stringify((this.state.dataPayload)))

        let countDataCopy = JSON.parse(JSON.stringify(this.state.countData))
    
        //    let find =  BulkOperationData.filter((item)=>{
        //     if(item[data.key] ){
        //         return item
        //     }
        // })
    
        // data.key ki jagah data.productName use karo
        // kyunki payload mein key = serviceName hi hai
        let find = BulkOperationData.filter((item) => {
            if (item[data.productName]) { return item }
        })
        //  return
       
        // let final = find[0][data.key]
         let final = find[0][data.productName]
        let TransformBulkData = JSON.parse(JSON.stringify(final))
        // console.log("status:::",data.status)
        // console.log("find", find)
        // console.log("final", final)
        // return
    
      let sendToPayload =  final.filter(order => {
            if(data.status == "KOT_GENERATED"){
            order.items = order.items.filter( service => service.status == 'IN_PROCESS');
            }else{
                order.items = order.items.filter( service => service.status == 'PREPARED'); 
            }
            return order.items.length > 0;
        });

        //     console.log('🟣 MUTATION KO JA RAHA HAI::', JSON.stringify(sendToPayload, null, 2))

        // console.log("sendToPayload",sendToPayload)
    
        // TransformBulkData = TransformBulkData.filter(order => {
        //     if(data.status == "KOT_GENERATED"){
        //     order.items = order.items.filter( service => service.status != 'IN_PROCESS');
        //     }else{
        //         order.items = order.items.filter( service => service.status != 'PREPARED'); 
        //     }
        //     return order.items.length > 0;
        // });
    
    //     let foundObjectIndex = BulkOperationData.findIndex(obj => Object.keys(obj)[0] === data.productName);  
    //     console.log("foundObject::",foundObjectIndex)
    
    
    //     let CopyOfBulkData = BulkOperationData
    
    //   if (TransformBulkData.length === 0) {
    //     CopyOfBulkData.splice(foundObjectIndex, 1);
    //   } else {
    //     CopyOfBulkData[foundObjectIndex][Object.keys(CopyOfBulkData[foundObjectIndex])[0]] = TransformBulkData;
    //   }
    
        //  console.log("filteredArrT final:::",sendToPayload)
        //  console.log("TransformBulkData::",TransformBulkData)
        //  console.log("CopyOfBulkData:::",CopyOfBulkData)
        //  return
         
        let promise = [];
        try
        {
         this.setState({readyAllLoading:true,selectedItem:data}) 
        for(let i=0; i<sendToPayload.length; i++){
            //   console.log(final[i])
          promise.push(this.callReadyAll(sendToPayload[i]))  
        }
    
        let response = await Promise.all(promise)
     
        if(response.length){
        // let FilterData =  countDataCopy.filter((item)=>{
        //       if(item.productName == data.productName && item.status == data.status){
        //         return false
        //       }else{
        //          return item
        //       }
        //   })
        //   console.log("FilterData Mutation::",FilterData)
          message.success("Updated  Successfully")
          this.setState({readyAllLoading:false,selectedItem:null})
          
        }
       }catch(err){
              console.log("err",err)
        }
        
    
      }
    

    render() {
const MENU_OPTIONS = [
    { label: "Dine In", value: "dine-in" },
    { label: "Parcel", value: "parcel" },
    { label: "Online Menu", value: "online-menu" }
];
        

        const columns = [
            {
                title: (
                    <p style={{ margin: 0, fontSize: this.props.platform === "desktop" ? "16px" : "12px", fontWeight: "bold", color: "white" }}>
                        ATTACHED CATEGORY
                    </p>
                ),
                dataIndex: "attachedCat",
                width: "20%",
                responsive: ['xs', 'sm', 'md', 'lg'],
                render: text => (
                    <p style={{ margin: 0, fontSize: this.props.platform === "desktop" ? "15px" : "12px", fontWeight: "bold" }}>
                        {/* {text ? text.toUpperCase() : '-'} */}
                        {text ? unslugify(text) : "-"}
                    </p>
                )
            },
            {
                title: (
                    <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "16px" : "12px", fontWeight: "bold", color: "white" }}>
                        MENU ITEM
                    </p>
                ),
                dataIndex: "productName",
                width: "35%",
                responsive: ['xs', 'sm', 'md', 'lg'],
                render: text => (
                    <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "15px" : "12px", fontWeight: "bold" }}>
                        {text}
                    </p>
                )
            },

            // {
            //     title: (
            //         <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "16px" : "12px", fontWeight: "bold", color: "white" }}>
            //             ORDER FROM
            //         </p>
            //     ),
            //     dataIndex: "subOrderFrom",
            //     // width: "20%",
            //     responsive: ['xs', 'sm', 'md', 'lg'], 
            //     render: text => (
            //         <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "15px" : "12px", fontWeight: "bold" }}>
            //             {/* {text} */}
            //              {unslugify(text).toUpperCase()}
            //         </p>
            //     )
            // },

            {
                title: (
                    <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "16px" : "12px", fontWeight: "bold", color: "white" }}>
                        QUANTITY
                    </p>
                ),
                dataIndex: "quantity",
                width: "15%",
                responsive: ['xs', 'sm', 'md', 'lg'],
                render: text => (
                    <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "15px" : "12px", fontWeight: "bold" }}>
                        {text}
                    </p>
                )
            },

            {
                title: (
                    <p style={{ margin: 0, marginLeft: "0rem", fontSize: this.props.platform === "desktop" ? "16px" : "12px", fontWeight: "bold", color: "white" }}>
                        ACTION
                    </p>
                ),
                width: "30%",
                responsive: ['xs', 'sm', 'md', 'lg'],
                render: data => (
                    <Button
                        style={{
                            background: data.status === "KOT_GENERATED"
                                ? "rgb(241, 74, 82)"
                                : "#75a85a",
                            color: "white"
                        }}
                        loading={
                            this.state.selectedItem
                                ? this.state.selectedItem.productName === data.productName &&
                                this.state.selectedItem.status === data.status
                                : false
                        }
                        onClick={() => this.readyAll(data)}
                    >
                        {data.status === "KOT_GENERATED" ? "Accept All" : "Ready All"}
                    </Button>
                )
            }
        ];
        
      
        return (
            <>
             <style>{`
                .order-from-dropdown .ant-select-item-option:hover {
                    background-color: #e8f4fd !important;
                }
                .order-from-dropdown .ant-select-item-option-selected {
                    background-color: #d0eaff !important;
                }
            `}</style>

            {/* New Select Box */}
            <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 8 }}>
                    {/* <Select
                        mode="multiple"
                        allowClear
                        maxTagCount={1}
                        popupClassName="order-from-dropdown"
                        placeholder={<span style={{ color: '#555' }}>&nbsp;Order From — All</span>}
                        style={{ minWidth: 220, borderRadius: 8 }}
                        dropdownStyle={{ borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        suffixIcon={<span style={{ color: '#4caf50', fontSize: 16, fontWeight: 'bold' }}>▾</span>}
                        onChange={(values) => this.setState({ selectedMenuTypes: values })}
                        value={this.state.selectedMenuTypes}
                        menuItemSelectedIcon={null}
                    >
                        {this.props?.menuTypes && this.props?.menuTypes.map(menu => {
                            const isSelected = this.state.selectedMenuTypes.includes(menu.slugName);
                            return (
                                <Select.Option key={menu.slugName} value={menu.slugName}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{
                                            width: 16, height: 16,
                                            borderRadius: 3,
                                            border: `2px solid ${isSelected ? '#4caf50' : '#ccc'}`,
                                            backgroundColor: isSelected ? '#4caf50' : 'white',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}>
                                            {isSelected && (
                                                <span style={{ color: 'white', fontSize: 10, fontWeight: 'bold' }}>✓</span>
                                            )}
                                        </span>
                                        {menu.typeName}
                                    </span>
                                </Select.Option>
                            );
                        })}
                    </Select> */}
                    <Select
                        mode="multiple"
                        allowClear
                        maxTagCount={1}
                        popupClassName="order-from-dropdown"
                        placeholder={<span style={{ color: '#555' }}>&nbsp;Order From — All</span>}
                        style={{ minWidth: 220, borderRadius: 8 }}
                        dropdownStyle={{ borderRadius: 8, boxShadow: '0 4px 12px rgba(0,0,0,0.1)' }}
                        suffixIcon={<span style={{ color: '#4caf50', fontSize: 16, fontWeight: 'bold' }}>▾</span>}
                        onChange={(values) => this.setState({ selectedMenuTypes: values })}
                        value={this.state.selectedMenuTypes}
                        menuItemSelectedIcon={null}
                    >
                        {MENU_OPTIONS.map(menu => {
                            const isSelected = this.state.selectedMenuTypes.includes(menu.value);

                            return (
                                <Select.Option key={menu.value} value={menu.value}>
                                    <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                                        <span style={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: 3,
                                            border: `2px solid ${isSelected ? '#4caf50' : '#ccc'}`,
                                            backgroundColor: isSelected ? '#4caf50' : 'white',
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            flexShrink: 0
                                        }}>
                                            {isSelected && (
                                                <span style={{ color: 'white', fontSize: 10, fontWeight: 'bold' }}>✓</span>
                                            )}
                                        </span>
                                        {menu.label}
                                    </span>
                                </Select.Option>
                            );
                        })}
                    </Select>
            </div>
            <div style={{ backgroundColor: "white" }}>
                {this.state.loading ? <Spin style={{ margin: "0 auto" }} /> : <Table
                    size='small'
                    className='count-table'
                    columns={columns}
                    dataSource={this.state.countData}
                    bordered
                    pagination={false}
                    key={"ItemViewTable"}
                    // rowKey={(record, index) => record.productName + record.subOrderFrom + index}
                    rowKey={(record, index) => record.productName + record.attachedCat + index}

                />

                }
            </div>
            </>
            
        );
    }
}

export default withApollo(ItemCount)

